export default {
  install(Vue) {
    const uploadArchivosValidos = [
      { type: "pdf", descripcion: "documento pdf", mimeType: "application/pdf" },
      { type: "xls", descripcion: "documento excel", mimeType: "application/vnd.ms-excel" },
      { type: "xlsx", descripcion: "documento excel", mimeType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
      { type: "ods", descripcion: "documento excel libre", mimeType: "application/vnd.oasis.opendocument.spreadsheet" },
      { type: "doc", descripcion: "documento word", mimeType: "application/msword" },
      { type: "docx", descripcion: "documento word", mimeType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
      { type: "odt", descripcion: "documento word libre", mimeType: "application/vnd.oasis.opendocument.text" },
      { type: "csv", descripcion: "documento de con separación", mimeType: "text/csv" },
      { type: "sql", descripcion: "archivo de base de datos", mimeType: "application/sql" },
      { type: "json", descripcion: "archivo de base de datos", mimeType: "application/json" },
      { type: "bak", descripcion: "archivo de base de datos", mimeType: "application/octet-stream" },
      { type: "txt", descripcion: "archivo de base de datos", mimeType: "application/octet-stream" },
      { type: "db", descripcion: "archivo de base de datos", mimeType: "application/octet-stream" },
      { type: "dump", descripcion: "archivo de base de datos", mimeType: "application/octet-stream" },
      { type: "zip", descripcion: "archivo comprimido", mimeType: "application/zip" },
      { type: "rar", descripcion: "archivo comprimido", mimeType: "application/vnd.rar" },
      { type: "tar", descripcion: "archivo comprimido", mimeType: "application/x-tar" },
      { type: "tar.gz", descripcion: "archivo comprimido", mimeType: "application/gzip" },
    ]
    const contantesDropZone = {
      cantidadMaximoArchivos: 6,
      tamanioMaximoArchivo: 30
    }
    const dominios = {
      TIPO_PREMIO_NORMA_ID: 'TipoPremioNormaID',
    }
    const mensajes = {
      DOUMENTO_NO_NOTIFICADO: 'Aún no se tiene el documento adjunto y/o el documento no esta aun notificado.'
    }
    const msjTipoObligatoriedad = {
      opcional: '(opcional)',
      obligatorio: '(obligatorio)',
      corresponda: '(sí corresponde)',
    }
    const msjTipoObligatoriedadSinParentesis = {
      opcional: 'opcional',
      obligatorio: 'obligatorio',
      corresponda: 'sí corresponde',
    }
    const dominios_id = {
      AMPLIACION_ID: 1700,
      MODIFICACION_ID: 1701,
      ACLARACION_ID: 2165,
      COMPLEMENTACION_ID: 2166,
      ENMIENDA_ID: 2167,
      ACLARACION_COMPLEMENTACION_ID: 2192,
      ACLARACION_ENMIENDA_ID: 2193,
      COMPLEMENTACION_ENMIENDA_ID: 2194,
      ACLARACION_COMPLEMENTACION_ENMIENDA_ID: 2195,
      ESTADO_SOLICITUD_INICIADO: 2158,
      ESTADO_DATO_SOLICITUD_INICIADO_ID: 3732,
      ESTADO_SOLICITUD_PREENVIADO_ID: 3731,
      TIPO_PRIORIDAD_ALTA_PAJEL: 3845,
      POR_DERIVAR_ID: 1164,
      CONCLUIDO_ID: 1640
    }
    const constTipoCaracteristica = {
      RESOLUCION_AUTORIDAD_REGULATORIA_COMPETENTE: 2109
    }
    const criterio_descripcion = {
      DOCS_ACLARACION_COMPL_ENMIENDA: 'DOCS_ACLARACION_COMPL_ENMIENDA'
    }
    const tramiteOpt = {
      opcionAutorizacionPromocionempresarial: '1000',
      opcionAmpliacionModificacion: '1001',
      opcionDesistimiento: '1002',
      opcionAclaracionComplEnm: '1003',
      opcionInclusionExclusion: '1004',
      opcionDocumentosPosteriores: '1005',
      opcionRenuncia: '1010',
      opcionMisPromocionesEmpresariales: '1011',
    }
    const menusAdministracionCuenta = [
      1009, // Desactivar Cuenta
      1008, // Actualizar Contraseña
    ]
    const menusAdministracionNoCuenta = [
      1007, // Actualizar Correo
    ]
    const etiquetaForm = {
      FormPromocion: "Datos de la Promoción Empresarial",
      FormRespaldosLegalesTecnicos: "Respaldos legales técnicos",
      FormDeclaracionVeracidad: "Declaración de veracidad y envio de la solicitud",
    }
    // CONSTANTES UTILIZADAS PARA LA VISUALIZACION DE PLANTILLAS
    const plantillas = [
      {
        tipoDocumentoProcesoId: 1070,
        nombreArchivo: "ProyectoModeloSolicitudAutorizacionPE.docx",
        descripcion: "modelo"
      },
      {
        tipoDocumentoProcesoId: 4021,
        nombreArchivo: "DeclaracionAnexo_II.docx",
        descripcion: "plantilla"
      },
      {
        tipoDocumentoProcesoId: 2080,
        nombreArchivo: "ListadoPremiosOfertados.xlsx",
        descripcion: "plantilla"
      },
      {
        tipoDocumentoProcesoId: 2081,
        nombreArchivo: "ListadoLugaresSorteo.xlsx",
        descripcion: "plantilla"
      },
      {
        tipoDocumentoProcesoId: 2082,
        nombreArchivo: "ListadoLugareEntregas.xlsx",
        descripcion: "plantilla"
      },
      {
        tipoDocumentoProcesoId: 3901,
        nombreArchivo: "platilla_declaracion_anexo_VI.docx",
        descripcion: "plantilla"
      },
    ]
    // CONSTANTES UTILIZADAS PARAR MARCAR DOCUMENTOS COMO OBLIGATORIOS (SOLO VISUALMENTE) MEDIANTE CRITERIO DOMINIO ID
    const docObligatorios = [
      // AUTORIZACION DE PE
      3893, //tipoDocumentoProcesoId: 1066 -> CEDULA DE IDENTIDAD/CEDULA DE IDENTIDAD REPRESENTANTE LEGAL
      3894, //tipoDocumentoProcesoId: 1067 -> CERTIFICADO INSCRIPCION PADRON NACIONAL DE CONTRIBUYENTES (SIN)
      3892, //tipoDocumentoProcesoId: 1070 -> PROYECTO DE DESARROLLO DE LA PROMOCION EMPRESARIAL
      // AMPLIACION/MODIFICACION DE PE
      3879, //tipoDocumentoProcesoId: 4013 -> SOLICITUD DE MODIFICACION Y/O AMPLIACION (NOTA O MEMORIAL)
      3891, //tipoDocumentoProcesoId: 2206 -> Testimonio de representante legal o poder legal
      // DESISTIMIENTO
      3878, //tipoDocumentoProcesoId: 4012 -> SOLICITUD DE DESISTIMIENTO (NOTA O MEMORIAL)
      // RENUNCIA
      3877, //tipoDocumentoProcesoId: 4010 -> SOLICITUD DE RENUNCIA (NOTA O MEMORIAL)
      // ACLARACION/COMPLEMENTACION/ENMIENDA
      3876, //tipoDocumentoProcesoId: 4009 -> SOLICITUD ACLARACIÓN COMPLEMENTACIÓN Y/O ENMIENDA (NOTA O MEMORIAL)
      // INCLUSION/EXCLUSION
      3920, //tipoDocumentoProcesoId: 4008 -> SOLICITUD INCLUSIÓN Y/O EXCLUSIÓN (NOTA O MEMORIAL)
    ]
    //El atributo "tipoArchivo" está relacionado con la variable de  "uploadArchivosValidos" si existe uno inexistente, se debe agregar en la variable luego en "tipoArchivo"
    const docTipoExtensionPersonalizado = [
      { id: 3907, tiposArchivo: ['pdf', 'xls', 'xlsx', 'ods', 'doc', 'docx', 'odt', 'csv', 'sql', 'json', 'bak', 'txt', 'db', 'dump', 'zip', 'rar', 'tar', 'tar.gz'], tamanioFile: 300, cantidadFile: 1 }
    ]
    const docObligatoriosSegunCorresponda = [
      // AUTORIZACION DE PE
      3895, //tipoDocumentoProcesoId: 4025 -> Matrícula actualizada del registro de comercio o equivalente
      3896, //tipoDocumentoProcesoId: 1068 -> Testimonio de constitucion de sociedad o doc. equivalente
      3897, //tipoDocumentoProcesoId: 4026 -> Testimonios de modificación de denominación o plazo duración
      3898, //tipoDocumentoProcesoId: 1069 -> Testimonio de poder del representante legal
      3899, //tipoDocumentoProcesoId: 2109 -> Resolución de aceptación para tramitar la autorización de la promoción empresarial emitida por la anh o asfi
      3900, //tipoDocumentoProcesoId: 1071 -> Contrato de servicio integrador
      3901, //tipoDocumentoProcesoId: 2141 -> Contrato de promocion compartida
      3902, //tipoDocumentoProcesoId: 1072 -> Contrato de servicio de valor agregado y numero corto
      3887, //tipoDocumentoProcesoId: 1228 -> Factura
      3883, //tipoDocumentoProcesoId: 4018 -> Declaración de mercancías de importación (dim) + gastos de desaduanización
      3888, //tipoDocumentoProcesoId: 1230 -> Proforma
      3884, //tipoDocumentoProcesoId: 4019 -> Aviso de consumo
      3889, //tipoDocumentoProcesoId: 1076 -> Certificacion premios ofertados
      3885, //tipoDocumentoProcesoId: 4020 -> Minuta de transferencia o documento de compromiso
      3886, //tipoDocumentoProcesoId: 4021 -> Declaración jurada (anexo ii)
      3890, //tipoDocumentoProcesoId: 1411 -> Contrato de servicio o compra
      3917, //tipoDocumentoProcesoId: 4038 -> Otros documentos tecnicos
      // AMPLIACION/MODIFICACION DE PE
      3887, //tipoDocumentoProcesoId: 1228 -> Factura
      3883, //tipoDocumentoProcesoId: 4018 -> Declaración de mercancías de importación (dim) + gastos de desaduanización
      3888, //tipoDocumentoProcesoId: 1230 -> Proforma
      3884, //tipoDocumentoProcesoId: 4019 -> Aviso de consumo
      3889, //tipoDocumentoProcesoId: 1076 -> Certificacion premios ofertados
      3885, //tipoDocumentoProcesoId: 4020 -> Minuta de transferencia o documento de compromiso
      3886, //tipoDocumentoProcesoId: 4021 -> Declaración jurada (anexo ii)
      3890, //tipoDocumentoProcesoId: 1411 -> Contrato de servicio o compra
      3917, //tipoDocumentoProcesoId: 4038 -> Otros documentos tecnicos
      // RENUNCIA
      3919, //tipoDocumentoProcesoId: 4039 -> Documento de respaldo de la solicitud
      // DOCUMENTOS POSTERIORES
      3903, //tipoDocumentoProcesoId: 1269 -> Acta de entrega de premios
      3904, //tipoDocumentoProcesoId: 1268 -> Acta de sorteo
      3905, //tipoDocumentoProcesoId: 2205 -> Acta provisional de recepción d premios caducados de lonabol
      3906, //tipoDocumentoProcesoId: 2210 -> Actas de sorteo y entrega de premios
      3907, //tipoDocumentoProcesoId: 2211 -> Base de datos de entrega de premios (multiformato)
      3908, //tipoDocumentoProcesoId: 1550 -> Nota de comunicación de existencia premios caducados
      3909, //tipoDocumentoProcesoId: 2202 -> Libro notariado entrega de premios
      3910, //tipoDocumentoProcesoId: 2204 -> Nota comunicación de transf. de premios caducados a lonabol
      3911, //tipoDocumentoProcesoId: 2203 -> Nota conformidad de lonabol de transf. de premios caducados
      3912, //tipoDocumentoProcesoId: 2224 -> Carta o memorial de premios entregados en un periodo mensual
      3913, //tipoDocumentoProcesoId: 2225 -> Libro registro entrega de premios en periodo de caducidad
      3914, //tipoDocumentoProcesoId: 2969 -> Acta de disposicion destruccion de medios de acc. al premio
      3915, //tipoDocumentoProcesoId: 3901 -> Dec. jurada de veracidad para remision de actas/libros nota.
      3916, //tipoDocumentoProcesoId: 1231 -> Otro
      3918, //tipoDocumentoProcesoId: 4037 -> Otros documentos legales
      // INCLUSION/EXCLUSION
      3921, //tipoDocumentoProcesoId: 4039 -> Documento de respaldo de la solicitud
    ]
    const docNoObligatorios = [
      // AUTORIZACION DE PE
      3880, //tipoDocumentoProcesoId: 2080 -> Lista de premios ofertados
      3881, //tipoDocumentoProcesoId: 2081 -> Lista de lugares y fechas de sorteo
      3882, //tipoDocumentoProcesoId: 2082 -> Lista de lugares y fechas de entrega de premios
      // AMPLIACION/MODIFICACION DE PE
      3880, //tipoDocumentoProcesoId: 2080 -> Lista de premios ofertados
      3881, //tipoDocumentoProcesoId: 2081 -> Lista de lugares y fechas de sorteo
      3882, //tipoDocumentoProcesoId: 2082 -> Lista de lugares y fechas de entrega de premios
    ]
    // CONSTANTES UTILIZADAS PARAR MOSTRAR AYUDAS VISUALES PARA EL CARGADO DE DOCUMENTOS
    const documentos_ayuda = [
      // PARA AUTORIZACION DE PE
      /* {
        criterioDominioId: 3893, //tipoDocumentoProcesoId: 1066 - CEDULA DE IDENTIDAD/CEDULA DE IDENTIDAD REPRESENTANTE LEGAL
        ayuda: 'Cédula de Identidad vigente del solicitante o solicitantes, o representante(s) legal(es).',
      }, */

      {
        criterioDominioId: 3907, //Base de datos de entrega de premios (multiformato) se muestra en documentos Posteriores
        ayuda: `Puedes subir un máximo de ${docTipoExtensionPersonalizado[0].cantidadFile} archivos, y cada archivo no debe superar los ${docTipoExtensionPersonalizado[0].tamanioFile} MB. O si tienes varios archivos o archivos grandes, puedes comprimirlos en un archivo ZIP, RAR o TAR antes de subirlos. Esto te permitirá subir más archivos y facilitará el proceso de carga.`,
      },
      {
        criterioDominioId: 3894, //tipoDocumentoProcesoId: 1067 - Certificado inscripcion padron nacional de contribuyentes (sin)
        ayuda: 'El Certificado de Inscripción debe ser extraído de la página web del Servicio de Impuestos Nacionales',
      },
      {
        criterioDominioId: 3895, //tipoDocumentoProcesoId: 4025 - Matrícula actualizada del registro de comercio o equivalente
        ayuda: 'Deben presentar las Empresas Unipersonales, SRL, S.A., etc.), en caso de Asociaciones, Cooperativas, Institutos y otros, deberán presentar documento equivalente emitido por autoridad competente.',
      },
      {
        criterioDominioId: 3896, //tipoDocumentoProcesoId: 1068 - Testimonio de constitucion de sociedad o doc. equivalente
        ayuda: 'Deben presentar las Empresas SRL, S.A., Ltda., etc., y documento equivalente para Asociaciones, Cooperativas, Institutos y otros.',
      },
      {
        criterioDominioId: 3897, //tipoDocumentoProcesoId: 4026 - Testimonios de modificación de denominación o plazo duración
        ayuda: 'Deben presentar cuando exista modificación de estatutos, incremento de capital, ingreso de socios, plazo de duración, denominación, etc.',
      },
      {
        criterioDominioId: 3898, //tipoDocumentoProcesoId: 1069 - Testimonio de poder del representante legal
        ayuda: 'Deben presentar las Empresas SRL, S.A., Ltda., etc., asimismo este documento pueden presentar las personas naturales o empresas unipersonales a través de un Poder Especial con facultades para la AJ.',
      },
      {
        criterioDominioId: 3899, //tipoDocumentoProcesoId: 2109 - Resolución de autorización para tramitar la autorización de la promoción emitida por autoridad competente
        ayuda: 'Deben presentar las empresas o entidades reguladas por la  ASFI, ANH u otras entidades.',
      },
      {
        criterioDominioId: 3900, //tipoDocumentoProcesoId: 1071 - Contrato de servicio integrador
        ayuda: 'Deben presentar el contrato de servicio integrador, las empresas contratadas para el desarrollo de una promoción empresarial (empresas publicitarias o marketing).',
      },
      {
        criterioDominioId: 3901, //tipoDocumentoProcesoId: 2141 - Contrato de promocion compartida
        ayuda: 'Se debe presentar cuando una promoción empresarial es desarrollada por 2 o más empresas, adjuntando los requisitos legales señalados en los puntos 1 al 6, de las empresas suscribientes.',
      },
      {
        criterioDominioId: 3902, //tipoDocumentoProcesoId: 1072 - Contrato de servicio de valor agregado y numero corto
        ayuda: 'Se debe presentar cuando una empresa desarrolla una promoción empresarial utilizando un número corto o número de teléfono.',
      },
      {
        criterioDominioId: 3918, //tipoDocumentoProcesoId: 4037 - Otros documentos legales
        ayuda: 'Se refiere a otra documentación legal de la empresa que considere necesario presentar.',
      },

      {
        criterioDominioId: 3892, //tipoDocumentoProcesoId: 1070 - Proyecto de desarrollo de la promocion empresarial
        ayuda: 'Documento que establece las características, modalidad de premiación, requisitos o condiciones de participación, premios ofertados, etc., de una promoción empresarial.',
      },
      {
        criterioDominioId: 3880, //tipoDocumentoProcesoId: 2080 - Lista de premios ofertados
        ayuda: 'Describir los premios ofertados en la promoción empresarial.',
      },
      /* {
        criterioDominioId: 3881, //tipoDocumentoProcesoId: 2081 - Lista de lugares y fechas de sorteo
        ayuda: 'Listado de los lugares y fechas de sorteo, si corresponde.',
      },
      {
        criterioDominioId: 3882, //tipoDocumentoProcesoId: 2082 - Lista de lugares y fechas de entrega de premios
        ayuda: 'Listado de los lugares y fechas de entrega de premios.',
      }, */

      {
        criterioDominioId: 3883, //tipoDocumentoProcesoId: 4018 - Declaración de mercancías de importación (dim) + gastos de desaduanización
        ayuda: 'Es el documento entregado por la Aduana Nacional por concepto de importación.',
      },
      {
        criterioDominioId: 3889, //tipoDocumentoProcesoId: 1076 - Certificacion premios ofertados
        ayuda: 'Cuando el premio es producido, vendido o prestado por la propia empresa.',
      },
      {
        criterioDominioId: 3885, //tipoDocumentoProcesoId: 4020 - Minuta de transferencia o documento de compromiso
        ayuda: 'Se debe presentar cuando los premios sean sujetos de registro público (inmuebles y vehículos).',
      },
      {
        criterioDominioId: 3886, //tipoDocumentoProcesoId: 4021 - Declaración jurada (anexo ii)
        ayuda: 'Se debe presentar en caso de que el premio sea en dinero.',
      },
      {
        criterioDominioId: 3917, //tipoDocumentoProcesoId: 4038 - Otros documentos tecnicos
        ayuda: 'Cualquier documento adicional que el administrado considere pertinente.',
      },

      // PARA AMPLIACION DE PE
      {
        criterioDominioId: 3879, //tipoDocumentoProcesoId: 4013 - Solicitud de modificacion y/o ampliacion (nota o memorial)
        ayuda: 'Nota o memorial presentado por el Administrado, donde se debe especificar las modificaciones y/o ampliaciones que requiere.',
      },

      {
        criterioDominioId: 3891, //tipoDocumentoProcesoId: 2206 - Testimonio de representante legal o poder legal
        ayuda: 'En caso de que la solicitud de ampliacion y/o modificación sea presentada por un representante legal distinto al que solicito la autorizacion de la promoción empresarial.',
      },

      // DESISTIMIENTO
      {
        criterioDominioId: 3878, //tipoDocumentoProcesoId: 4012 - Solicitud de desistimiento (nota o memorial)
        ayuda: 'Se puede presentar desistimiento hasta antes de la notificación con la Resolución Administrativa de Autorización.',
      },

      // RENUNCIA
      {
        criterioDominioId: 3877, //tipoDocumentoProcesoId: 4010 - Solicitud de renuncia (nota o memorial)
        ayuda: 'Se puede presentar la renuncia, siempre y cuando que no se haya iniciado la promoción; o si se hubiera iniciado, por causales de fuerza mayor o caso fortuito.',
      },
      {
        criterioDominioId: 3919, //tipoDocumentoProcesoId: 4039 - Documento de respaldo de la solicitud
        ayuda: 'En caso de que se presente por causales de fuerza mayor o caso fortuito, se debe adjuntar respaldo documental.',
      },

      // ACLARACION/COMPLEMENTACION/ENMIENDA
      {
        criterioDominioId: 3876, //tipoDocumentoProcesoId: 4009 - Solicitud aclaración complementación y/o enmienda (nota o memorial)
        ayuda: 'Se puede solicitar la aclaracion, complementacion y/o enmienda sobre errores materiales, de hecho o aritmeticos de la Resolucion y no sobre el fondo de la misma. Esta debe ser presentada en un plazo no mayor a 5 dias habiles posteriores a la notificación con la Resolución.',
      },

      // INCUSION/EXCLUSION
      {
        criterioDominioId: 3920, //tipoDocumentoProcesoId: 4008 - Solicitud inclusión y/o exclusión (nota o memorial)
        ayuda: 'Las empresas podrán solicitar la inclusión y/o exclusión de ánforas y/o puntos de canje autorizados las veces que vea conveniente. No se podrá disminuir la cantidad de los mismos.',
      },
      {
        criterioDominioId: 3921, //tipoDocumentoProcesoId: 4039 - Documento de respaldo de la solicitud
        ayuda: 'En caso de que la solicitud sea por fuerza mayor o caso fortuito se deberá adjuntar documentación de respaldo.',
      },

    ]
    const horariosAtencion = {
      manianaInicio: "09:00",
      manianaFin: "12:30",
      tardeInicio: "14:30",
      tardeFin: "19:00",
    }
    const alertasMensaje = {
      administrado: {
        alert1: { icon: '!', mensaje: `<strong>IMPORTANTE:</strong> La lista de representantes legales y/o apoderados de su empresa se actualiza continuamente con el testimonio de poder legal adjunto en sus solicitudes de autorización, ampliación o modificación de promociones empresariales. Por lo tanto, es importante que adjunte el documento actualizado de testimonio de poder legal para asegurar la correcta inclusión en el registro.` },
        alert2: { icon: '!', mensaje: `<strong>IMPORTANTE:</strong> Es su responsabilidad, como administrado, comunicar de manera oportuna cualquier actualización de los datos. La AJ no se responsabiliza por posibles perjuicios que puedan derivarse de la omisión de esta actualización en el procesamiento de sus trámites.` },
        alert3: { icon: '!', mensaje: `<strong>IMPORTANTE:</strong> Al aceptar este aviso, usted confirma que está al tanto de su información registrada ante la Autoridad de Fiscalización del Juego (AJ). Como administrado, es su responsabilidad comunicar cualquier actualización o modificación de dicha información de manera oportuna.` }

      }
    }
    const requisitosPorTramite =
      [
        {
          idTramite: "1000",
          tramite: "Autorización de promoción empresarial",
          datos: [
            {
              secuencia: "2",
              titulo: "Requisitos Legales",
              detalle: [
                {
                  subTitulo: "",
                  criterio: "DOCS_PE_LEGAL_PAJEL_v2",
                },
              ]

            },
            {
              secuencia: "3",
              titulo: "Requisitos Técnicos",
              detalle: [
                {
                  subTitulo: "Proyecto de promoción empresarial",
                  criterio: "DOCS_PE_PROYECTO_PAJEL_v2",

                },
                {
                  subTitulo: "Datos complementarios",
                  criterio: "DOCS_PREMIO_SORTEO_ENTREGA_PAJEL_v2",
                },
                {
                  subTitulo: "Respaldos técnicos al premio ofertado",
                  criterio: "DOCS_PE_TECNICO_PAJEL_v2",
                }
              ]

            }
          ]
        },
        {
          idTramite: "1001",
          tramite: "Ampliación y/o modificaciones",
          datos: [
            {
              secuencia: "1",
              titulo: "Respaldos de solicitud",
              mensaje: "Si se cambió de representante legal",
              detalle: [
                {
                  subTitulo: "Solicitud escrita y detalles de la ampliación y/o modificación",
                  criterio: "DOCS_AMPL_MOD_NOTA_MEMORIAL_PAJEL_v2",
                },

                {
                  subTitulo: "Datos complementarios",
                  criterio: "DOCS_PREMIO_SORTEO_ENTREGA_PAJEL_v2",
                },
                {
                  subTitulo: "Respaldos técnicos al premio ofertado (si modificó premios)",
                  criterio: "DOCS_PE_TECNICO_PAJEL_v2",
                },
                {
                  subTitulo: "Documentos legales",
                  criterio: "DOCS_PE_TECNICO_PAJEL_v2",
                }
              ]

            }
          ]
        },
        {
          idTramite: "1002",
          tramite: "Desistimiento a una solicitud",
          datos: [
            {
              secuencia: "1",
              titulo: "Detalles iniciales de la solicitud",
              mensaje: "Solicitud de desistimiento",
              detalle: [
                {
                  subTitulo: "Solicitud de desistimiento",
                  criterio: "DOCS_DESISTIMIENTO_SOLICITUD_PAJEL_v2",
                },
              ]
            }
          ]
        },
        {
          idTramite: "1010",
          tramite: "Renunciar a la autorización",
          datos: [
            {
              secuencia: "1",
              titulo: "Respaldos de solicitud",
              mensaje: "",
              detalle: [
                {
                  subTitulo: "Solicitud de renuncia",
                  criterio: "DOCS_RENUNCIA_SOLICITUD_PAJEL_v2",
                },
              ]
            }
          ]
        },
        {
          idTramite: "1003",
          tramite: "Aclaración/Complementación/enmienda",
          datos: [
            {
              secuencia: "1",
              titulo: "Respaldos de solicitud",
              mensaje: "",
              detalle: [
                {
                  subTitulo: "Solicitud de aclaración, complementación y/o enmienda",
                  criterio: "DOCS_ACLARA_COMPLE_ENMIENDA_NOTA_MEMORIAL_PAJEL_v2",
                },
              ]
            }
          ]
        },
        {
          idTramite: "1004",
          tramite: "Inclusión y/o exclusión",
          datos: [
            {
              secuencia: "1",
              titulo: "Respaldos de solicitud",
              mensaje: "",
              detalle: [
                {
                  subTitulo: "Solicitud inclusión / exclusión",
                  criterio: "DOCS_INCLUSION_EXCLUSION_PAJEL_v2",
                },
              ]
            }
          ]
        },
        {
          idTramite: "1005",
          tramite: "Documentos Posteriores (P.E.)",
          datos: [
            {
              secuencia: "1",
              titulo: "Respaldos de solicitud",
              mensaje: "",
              detalle: [
                {
                  subTitulo: "Documentos Posteriores a Remitir",
                  criterio: "DOCS_DOCS_POSTERIORES_SOLICITUD_PAJEL_v2_1",
                },
              ]
            }
          ]
        }
      ]

    const mensajeBandejaPE = {
      ampliacionModificacion: "Promociones Empresariales vigentes con Resolución Administrativa de Autorización notificada, las cuáles se encuentren en plazo para solicitar una Ampliación y/o Modificación.",
      desistimiento: "Promociones Empresariales y Ampliaciones y/o modificaciones hasta antes de la notificación de la Resolución correspondiente, las cuáles se encuentren en plazo para solicitar un Desistimiento.",
      renuncia: "Promociones Empresariales vigentes con Resolución Administrativa de Autorización notificada, las cuáles se encuentren en plazo para solicitar su Renuncia",
      aclaracionComplementacion: "Promociones empresariales vigentes con Resolución Administrativa de Autorización notificada, las cuáles se encuentren en plazo para solicitar su Aclaración Complementación y/o Enmienda.",
      inclusionExclusion: "Promociones empresariales vigentes con Resolución Administrativa de Autorización notificada, las cuáles se encuentren en plazo para solicitar su Inclusión y/o Exclusión",
      documentoPosterior: "Promociones empresariales con Resolución Administrativa de Autorización notificada, las cuáles deben estar en plazo para solicitar la remisión de Documentos Posteriores."
    }
    Vue.prototype.$const_dominio = dominios;
    Vue.prototype.$const_dominio_id = dominios_id;
    Vue.prototype.$mensajes = mensajes;
    Vue.prototype.$criterio_descripcion = criterio_descripcion;
    Vue.prototype.$constTipoCaracteristica = constTipoCaracteristica;
    Vue.prototype.$tramiteOpt = tramiteOpt;
    Vue.prototype.$etiquetaForm = etiquetaForm;
    Vue.prototype.$plantillas = plantillas;
    Vue.prototype.$docObligatorios = docObligatorios;
    Vue.prototype.$docObligatoriosSegunCorresponda = docObligatoriosSegunCorresponda;
    Vue.prototype.$docTipoExtensionPersonalizado = docTipoExtensionPersonalizado;
    Vue.prototype.$docNoObligatorios = docNoObligatorios;
    Vue.prototype.$documentos_ayuda = documentos_ayuda;
    Vue.prototype.$menusAdministracionCuenta = menusAdministracionCuenta;
    Vue.prototype.$menusAdministracionNoCuenta = menusAdministracionNoCuenta;
    Vue.prototype.$horariosAtencion = horariosAtencion;
    Vue.prototype.$uploadArchivosValidos = uploadArchivosValidos
    Vue.prototype.$contantesDropZone = contantesDropZone
    Vue.prototype.$requisitosPorTramite = requisitosPorTramite
    Vue.prototype.$msjTipoObligatoriedad = msjTipoObligatoriedad
    Vue.prototype.$msjTipoObligatoriedadSinParentesis = msjTipoObligatoriedadSinParentesis
    Vue.prototype.$alertasMensaje = alertasMensaje
    Vue.prototype.$mensajeBandejaPE = mensajeBandejaPE
  }
}
